<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-xxl-4 text-white m-7" v-if="kelas.length == 0">
        Mohon tunggu, sedang mengunduh data
      </div>
    </div>
    <ChooseClass v-if="kelas.length > 0" :kelas="kelas"></ChooseClass>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ChooseClass from "@/view/content/widgets/custom/ChooseClass.vue";
import axios from "axios";

export default {
  name: "pilihkelas",
  components: {
    ChooseClass
  },
  data() {
    return {
      baseUrl: "https://backend-siradi2.azurewebsites.net",
      apiURL: "https://backend-siradi2.azurewebsites.net/guru",
      kelas: [],
      tingkat: "XI"
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.fetchKelas();
  },
  methods: {
    fetchKelas() {
      return axios.get(this.baseUrl + "/kelas").then(response => {
        this.kelas = response.data.filter(k => k.tingkat == this.tingkat);
        this.kelas = this.kelas.sort(function(x, y) {
          let a = x.label.toUpperCase(),
            b = y.label.toUpperCase();
          return a == b ? 0 : a > b ? 1 : -1;
        });
      });
    }
  }
};
</script>
